export default __webpack_public_path__ + "static/media/fifa-logo-icon.18a23e39.png";